import { render, staticRenderFns } from "./Incorporation.vue?vue&type=template&id=0bdbfe3d&scoped=true&"
import script from "./Incorporation.vue?vue&type=script&lang=js&"
export * from "./Incorporation.vue?vue&type=script&lang=js&"
import style0 from "./Incorporation.vue?vue&type=style&index=0&id=0bdbfe3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdbfe3d",
  null
  
)

export default component.exports